<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Clientes', 'link' : '/client' },
      ]"
    />

    <div class="row print-no-show">
      <div class="col-6">
        <span class="mb-2 fw-bold">Detalhes do Cliente</span>
      </div>
      <div class="col-6 text-end">
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/client/new', query: { edit: true, id: dados.id } }">
          <i class="bi bi-pencil-fill me-2"></i>Editar
        </router-link>
        <button v-show="isAdmin" @click="showModal_delete()" class="btn btn-sm btn-danger me-2"><i class="bi bi-trash3-fill me-2"></i>Deletar</button>
        <button @click="imprimir()" class="btn btn-sm btn-secondary"><i class="bi bi-printer me-2"></i>Imprimir</button>
      </div>
    </div>
    <hr class="print-no-show"/>

    <div v-if="dados.id != null" class="row">
      <div class="col mx-auto " style="margin-bottom: 40px;" id="conteudoParaImprimir">
        <div class="card">
          <div class="card-body">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="1">Cliente: {{ dados.name }}</td>
                  <td colspan="1">Cidade: {{ dados.city }}</td>
                </tr>
                <tr v-if="dados.type == 'PJ'">
                  <td colspan="2">Nome Legal: {{ dados.name_legal }}</td>
                </tr>
                <tr>
                  <td>Tipo: {{ dados.type }}</td>
                  <td><span>{{ dados.type == 'PF' ? 'CPF' : 'CNPJ' }}</span>: {{ dados.cpf_cnpj }}</td>
                </tr>
                <tr>
                  <td>Endereço: {{ dados.address }}</td>
                  <td>Email: {{ dados.email }}</td>
                </tr>
                <tr>
                  <td>Estado: {{ dados.state }}</td>
                  <td>CEP: {{ dados.zipcode }}</td>
                </tr>
                <tr>
                  <td>Aniversário: {{ dados.birthdate_incorporation }}</td>
                  <td>Anotações: {{ dados.note }}</td>
                </tr>

                <tr v-if="dados.type == 'PJ'">
                  <td>Nome do Responsável: {{ dados.responsible_name }}</td>
                  <td>Telefone do Responsável: {{ dados.responsible_phone }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-6 mt-2">
          <span class="mb-2 fw-bold">Locações</span>
        </div>
        <div class="card mt-2 p-2" v-if="dados.rentals.length != 0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 5%;" scope="col"></th>
                <th scope="col">Id</th>
                <th scope="col">Início</th>
                <th scope="col">Fim</th>
                <th scope="col">Total</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              
              <tr v-for="item in dados.rentals" :key="item.id">
                <td>
                  <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/rental/details', query: { id: item.id } }">
                    <i class="bi bi-eye-fill"></i>
                  </router-link>
                </td>
                <th scope="row">{{ item.id }}</th>
                <td>{{ dateFormat.dateTime(item.rental_date_start) }}</td>
                <td>{{ dateFormat.dateTime(item.rental_date_end) }}</td>
                <td>R$ {{ item.total_amount.toFixed(2) }}</td>
                <td>{{ statusFormat.status(item.status) }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Modal de Delete -->
    <div class="modal fade" id="modal_delete" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Confirmar Exclusão</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
            <p class="mt-3">Tem certeza que deseja excluir o cliente: <strong></strong></p>
            <p class="text-muted small">Esta ação não pode ser desfeita e pode afetar o estoque.</p>
          </div>
          <div class="modal-footer">
              <button type="button" @click="closeModal" class="btn btn-secondary">Cancelar</button>
              <button type="button" @click="confirmExcluir" :disabled="deleteLoading" class="btn btn-danger">
                <span v-if="deleteLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Excluir</span>
              </button>
          </div>
        </div>  
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import { onMounted, reactive, ref } from 'vue';
import { usePermissions } from '@/composables/usePermissions';
import { clientes } from '@/models/clientes';
import { parseError } from '@/utils/errorHelper';
import { Modal } from "bootstrap";
import { useToastStore } from '@/stores/toastStore';
import PainelLayout from '@/layouts/PainelLayout.vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import statusFormat from '@/services/statusFormat.js';
import dateFormat from '@/services/dateFormat';
import router from '@/router';

export default {
  name: "DetailsView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const { isAdmin,isOpeto,isUser } = usePermissions();
    var modal = '';
    const urlReturn = '/client';
    var deleteLoading = ref(false);
    const model = clientes();
    const toastStore = useToastStore();

    function goReturn() {
      router.push(urlReturn);
    }

    var dados = reactive({
      id: null,
      rentals: [],
      name_legal: null,
      name: null,
      phone: null,
      address: null,
      number: null,
      neighbor: null,
      city: null,
      state: null,
      zipcode: null,
      note: null,
      type: null,
      cpf_cnpj: null,
      email: null,
      birthdate_incorporation: null
    });

    function imprimir() {
      window.print();
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete() {
      openModal('modal_delete');
    }

    function confirmExcluir() {
      deleteLoading.value = true;
      model.delet(dados.id).then(() => {
        toastStore.success('Cliente excluído com sucesso.');
        closeModal();
        goReturn();
      }).catch((error) => {
        deleteLoading.value = false;
        toastStore.error('Erro ao excluir cliente: ' + parseError(error));
      });
    }

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id');
//	responsible_phone	responsible_name
      model.getOne(id).then((response) => {
          dados.id = response.id;
          dados.type = response.type;
          dados.rentals = response.rentals;
          dados.cpf_cnpj = response.cpf_cnpj;
          dados.email = response.email;
          dados.name = response.name;
          dados.name_legal = response.name_legal;
          dados.phone = response.phone;
          dados.responsible_name = response.responsible_name;
          dados.responsible_phone = response.responsible_phone;
          dados.birthdate_incorporation = response.birthdate_incorporation;
          dados.address = response.address;
          dados.number = response.number;
          dados.neighbor = response.neighbor;
          dados.city = response.city;
          dados.state = response.state;
          dados.zipcode = response.zipcode;
          dados.note = response.note;
      });
    });

    return {
      dados,isAdmin,isOpeto,isUser,
      statusFormat,goReturn, urlReturn, parseError,
      dateFormat, deleteLoading, showModal_delete, closeModal, confirmExcluir,
      imprimir
    }
  }
}
</script>

<style scoped>

  .header-print {
    display: none;
  }

  @media print {
    /* Esconde tudo no corpo */
    body * {
      visibility: hidden;
    }

    .print-no-show {
      display: none !important;
    }

    .header-print {
      display: block;
      margin-bottom: 20px;
      margin-top: -10px;
    }
    
    /* Mostra apenas a div de impressão */
    #conteudoParaImprimir, #conteudoParaImprimir * {
      visibility: visible;
    }
    
    /* Opcional: Forçar quebra de página */
    #conteudoParaImprimir p {
      page-break-inside: avoid;
    }
  }

</style>